<template>
  <v-icon
    small
    :color="getIconColor"
  >
    {{ getIcon }}
  </v-icon>
</template>

<script>
export default {
  props: {
    value: { required: true },
  },
  computed: {
    getIcon() {
      return this.value ? 'mdi-check-circle-outline' : 'mdi-alert-circle-outline';
    },
    getIconColor() {
      return this.value ? 'green' : 'orange';
    },
  },
};
</script>
